var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHevenlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 33,
    viewBox: "0 0 98 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2814 19.693L85.6859 7.88026H79.4607V32.8348H85.3711V21.671L90.9666 32.8348H97.1916V7.88026H91.2814V19.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7299 32.8348H76.834V26.9246H67.6401V21.671H74.8637V15.7607H67.6401V13.7905H76.834V7.88026H61.7299V32.8348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2227 11.8205L55.1629 10.5071L50.5661 18.3875L54.5061 17.0741L46.6259 30.8648L48.5959 20.3575L44.6376 21.671L46.6259 14.4473L42.6856 15.7607L44.6556 7.88026H36.7754L43.3422 32.8348H53.8495L60.4166 7.88026H53.1927L51.2227 11.8205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3579 32.8348H35.462V26.9246H26.2681V21.671H33.4918V15.7607H26.2681V13.7905H35.462V7.88026H20.3579V32.8348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8211 15.753L5.91082 16.9518V7.88026H0.000366211V32.8348H5.91082V22.9824L11.8211 21.7837V32.8348H17.7313V7.88026H11.8211V15.753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.91022H97.1917V-2.14577e-05H0V5.91022Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.1917,
    height: 32.8349,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHevenlogo);
export default __webpack_public_path__ + "static/media/hevenlogo.4ea3a20e076d32018d21cbf6e62500e2.svg";
export { ForwardRef as ReactComponent };